import { useUserSettings } from "@/contexts"
import type { QueryKey } from "@tanstack/react-query"

import type { ServiceAction, ServiceEntityKey, ServiceName } from "../types"
import { createQueryKey } from "./createQueryKey"

/**
 * Create a query key including the currency
 * @see {@link createQueryKey} for query key creation
 */
export const useQueryKey = (
  serviceName: ServiceName,
  serviceAction: ServiceAction,
  serviceEntityKey: null | ServiceEntityKey = null,
  // Mass eslint disable @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  serviceOptions: Record<string, any> = {}
): QueryKey => {
  const ignoreCurrency = serviceOptions.ignoreCurrency as boolean | undefined

  const { currency } = useUserSettings(ignoreCurrency)

  return createQueryKey(serviceName, serviceAction, serviceEntityKey, {
    ...serviceOptions,
    currency,
  })
}
